import { useEffect, useState } from "@wordpress/element";
import React from "react";
import {
  RefinementListProps,
  useClearRefinements,
  useInstantSearch,
  useRefinementList,
} from "react-instantsearch";

function ToggleOuiNon(props: RefinementListProps) {
  const [checked, setChecked] = useState(false);
  const { items, refine } = useRefinementList(props);
  const { refine: clearRefine } = useClearRefinements({
    includedAttributes: [props.attribute],
  });
  const { uiState } = useInstantSearch();

  const handleToggle = (e) => {
    const isChecked = e.target.checked;
    setChecked(isChecked);
    const value = isChecked ? "Oui" : undefined;
    clearRefine();
    refine(value);
  };

  useEffect(() => {
    const refinements = uiState?.prod_SallePublique.refinementList ?? null;

    if (!refinements) {
      setChecked(false);
    }
    console.log("uiState", uiState, "refinements", refinements);
  }, [uiState, props.attribute]);

  const ToggleLabel = () => {
    const serachValue = checked ? "Oui" : "Non";
    const item = items.find((item) => item.value === serachValue);
    if (!item) return null;

    return (
      <span className="toggle-label">
        <span className="ais-RefinementList-count"></span>
      </span>
    );
  };

  return (
    <div className="refinement-list">
      <h4 className="refinement-list__header">
        <span className="refinement-list__title">{props.title}</span>
        <label className="toggle-oui-non">
          <input
            id="chkToggle"
            type="checkbox"
            checked={checked}
            onChange={handleToggle}
          />
          <span className="toggle-slider" />
          <ToggleLabel />
        </label>
      </h4>
    </div>
  );
}

export default ToggleOuiNon;
